import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { MapCableDataPoint } from '@/server/MakeSenseApp-backend'
import { TEMPERATURE_CONFIG } from '@/constants/temperatureConstants'
import { PropType, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CableTemperature',
  props: {
  sensorReadings: {
    type: Array as PropType<MapCableDataPoint[]>,
    required: true
  },
  isVisible: {
    type: Boolean,
    required: true
  }
},
  setup(__props) {

const strokeWidth = ref(18)
const opacity = ref(1)

const props = __props

const getColor = (dts: number | undefined | null) => {
  if (dts === undefined || dts === null) {
    return 'rgba(0, 0, 0, 0)'
  }

  const { colors, thresholds } = TEMPERATURE_CONFIG
  
  if (dts < thresholds.low) {
    return colors[0]
  } else if (dts >= thresholds.low && dts < thresholds.medium) {
    return colors[1]
  } else if (dts >= thresholds.medium && dts < thresholds.high) {
    return colors[2]
  } else {
    return colors[3]
  }
}

const getNextColor = (index: number) => {
  const sensorReading = props.sensorReadings[index + 1]
  return getColor(sensorReading.dts)
}

return (_ctx: any,_cache: any) => {
  const _component_ol_geom_line_string = _resolveComponent("ol-geom-line-string")!
  const _component_ol_style_flowline = _resolveComponent("ol-style-flowline")!
  const _component_ol_feature = _resolveComponent("ol-feature")!
  const _component_ol_source_vector = _resolveComponent("ol-source-vector")!
  const _component_ol_vector_layer = _resolveComponent("ol-vector-layer")!

  return (_openBlock(), _createBlock(_component_ol_vector_layer, {
    zIndex: "1",
    className: "dts-map-vector-layer",
    opacity: opacity.value,
    visible: __props.isVisible
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ol_source_vector, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sensorReadings.slice(0, -1), (sensor, index) => {
            return (_openBlock(), _createBlock(_component_ol_feature, { key: index }, {
              default: _withCtx(() => [
                _createVNode(_component_ol_geom_line_string, {
                  coordinates: [
            [__props.sensorReadings[index].coordinate?.easting, __props.sensorReadings[index].coordinate?.northing],
            [
              __props.sensorReadings[index + 1].coordinate?.easting,
              __props.sensorReadings[index + 1].coordinate?.northing
            ]
          ]
                }, null, 8, ["coordinates"]),
                _createVNode(_component_ol_style_flowline, {
                  color: getColor(sensor.dts),
                  color2: getNextColor(index),
                  width: strokeWidth.value,
                  width2: strokeWidth.value,
                  arrow: 0,
                  lineCap: "round"
                }, null, 8, ["color", "color2", "width", "width2"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["opacity", "visible"]))
}
}

})